import { Icon } from "@chakra-ui/react";
import { FaExclamationTriangle } from "react-icons/fa";
import { crm, Pill } from "../theme";

const ProcessUrgencyBadge = ({ compact = false }: { compact?: boolean }) => (
  <Pill bg={crm.danger} color="white">
    <Icon as={FaExclamationTriangle} boxSize={compact ? "9px" : "10px"} aria-hidden />
    Urgente
  </Pill>
);

export default ProcessUrgencyBadge;
